import { render } from "./BaseSidebarViewerPanel.vue?vue&type=template&id=50aa6b2f&scoped=true"
import script from "./BaseSidebarViewerPanel.vue?vue&type=script&lang=js"
export * from "./BaseSidebarViewerPanel.vue?vue&type=script&lang=js"

import "./BaseSidebarViewerPanel.vue?vue&type=style&index=0&id=50aa6b2f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50aa6b2f"]])

export default __exports__